import { z } from 'zod';
import { LoginPeriod, UserActivityType } from '@/features/superAdmin/features/dashboard/types/super-admin-dashboard-dto';

export const SuperAdminDashboardPageFilterFormSchema = z.object({  
  startDate: z
    .date({ message: 'elements.form.startDate.error' })
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
  reportPeriod: z
    .nativeEnum(LoginPeriod),
  activityType: z
    .nativeEnum(UserActivityType)
    .nullable()
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: 'elements.form.datesDifference.error',
    path: ['endDate'],
  },
);